import { useTranslation } from "react-i18next";

const reasons = [
  {
    icon: "ri-robot-2-line",
    titleKey: "why.reason0_title",
    descKey: "why.reason0_desc",
    tone: "primary" as const,
  },
  {
    icon: "ri-bar-chart-box-line",
    titleKey: "why.reason1_title",
    descKey: "why.reason1_desc",
    tone: "accent" as const,
  },
  {
    icon: "ri-shield-check-line",
    titleKey: "why.reason2_title",
    descKey: "why.reason2_desc",
    tone: "primary" as const,
  },
  {
    icon: "ri-trophy-line",
    titleKey: "why.reason3_title",
    descKey: "why.reason3_desc",
    tone: "accent" as const,
  },
];

const gradientStyle = {
  background: "linear-gradient(90deg, #215E88, #02B36D)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

export default function WhyAI() {
  const { t } = useTranslation();

  return (
    <section id="por-que-ia" className="relative py-24 md:py-32 bg-background-50 overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-40 pointer-events-none"></div>
      <div className="absolute -top-32 -left-24 w-[420px] h-[420px] radial-glow opacity-40 pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold">
            <span className="w-2 h-2 rounded-full bg-primary-600"></span>
            {t("why.badge")}
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight">
            <span className="text-primary-500">{t("why.h2_part1")}</span>
            <span className="brand-gradient-text">{t("why.h2_gradient")}</span>
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: "#215E88" }}>
            {t("why.stats_part1")}
            <strong style={gradientStyle}>{t("why.stats_78")}</strong>
            {t("why.stats_part2")}
            <strong style={gradientStyle}>{t("why.stats_12")}</strong>
            {t("why.stats_part3")}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {reasons.map((r) => (
            <div
              key={r.titleKey}
              className="glass-card glow-border rounded-lg p-6 md:p-8 flex gap-5 items-start transition-all duration-300 ease-out hover:-translate-y-1"
              style={{
                boxShadow: 'none',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(2, 179, 109, 0.18), 0 4px 12px rgba(2, 179, 109, 0.10)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <span className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-md bg-gradient-to-br from-primary-600 to-accent-500 text-background-50">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${r.icon} text-2xl`}></i>
                </span>
              </span>
              <div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-primary-500">
                  {t(r.titleKey)}
                </h3>
                <p className="mt-2 text-sm md:text-base leading-relaxed" style={{ color: "#215E88" }}>
                  {t(r.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}